import { LOGIN_POPUP_SHOW, SET_ACCESS_TOKEN } from './actions'
import { LOGOUT } from '../user/actions'


const initialState = {
	accessToken: '',
	isShowLogin: false
}

export default (state = initialState, action) => {
	switch (action.type) {
	case LOGOUT: {
		return {
			...initialState
		}
	}
	case LOGIN_POPUP_SHOW: {
		return {
			...state,
			isShowLogin: action.payload
		}
	}
	case SET_ACCESS_TOKEN: {
		return {
			...state,
			accessToken: action.payload
		}
	}

	default: {
		return state
	}
	}
}
